import React from "react";

import {
    RiAccountCircleLine,
    RiAlarmLine,
    RiArrowUpDoubleFill,
    RiCalendarEventLine,
    RiDiscussLine,
    RiFolderOpenLine,
    RiMessage2Line,
    RiPriceTag2Line,
    RiShareLine,
    RiSpeedLine,
    RiTimeLine,
    RiUserLine,
} from "@remixicon/react";

import Toggle from "../../../theme/toggle/Toggle";

export const CARD_OPTIONS = [
    { value: "urn:fq:form-field:subject", label: "Subject", icon: RiFolderOpenLine },
    { value: "urn:fq:form-field:lastReplyMessage", label: "Last Reply Message", icon: RiMessage2Line },
    { value: "urn:fq:form-field:lastReplyDate", label: "Last Reply Time", icon: RiTimeLine },
    { value: "urn:fq:form-field:priority", label: "Priority", icon: RiArrowUpDoubleFill },
    { value: "urn:fq:form-field:sla", label: "SLAs", icon: RiAlarmLine },
    { value: "urn:fq:form-field:ticketSource", label: "Source", icon: RiShareLine },
    { value: "urn:fq:form-field:assigneeId", label: "Assignee", icon: RiAccountCircleLine },
    { value: "urn:fq:form-field:requesterId", label: "Requester", icon: RiUserLine },
    { value: "urn:fq:form-field:createdDate", label: "Date Created", icon: RiCalendarEventLine },
    { value: "urn:fq:form-field:requestType", label: "Request Type", icon: RiPriceTag2Line },
    { value: "urn:fq:form-field:queueId", label: "Queue", icon: RiSpeedLine },
    { value: "urn:fq:form-field:replyCount", label: "Number of Replies", icon: RiDiscussLine },
];

export default function CardLayout({
    value,
    onChange,
}: {
    value: string[]
    onChange(value: string[]): void
}) {
    const selectedSet = new Set(value ?? []);
    return (
        <div className="d-flex flex-column gap3-2 text-body-2-medium">
            {CARD_OPTIONS.map(option => (
                <div className="d-flex justify-content-between align-items-baseline" key={option.value}>
                    <div className="text-body-primary">
                        <span className="m3e-1 icon-secondary">
                            <option.icon size={20} />
                        </span>
                        {option.label}
                    </div>
                    <Toggle
                        size="small"
                        checked={selectedSet.has(option.value)}
                        onChange={event => {
                            if (event.target.checked) {
                                onChange([...value, option.value]);
                            } else {
                                onChange(value.filter(row => row !== option.value));
                            }
                        }}
                    />
                </div>
            ))}
        </div>
    );
}
